// extracted by mini-css-extract-plugin
export default {"labelDescriptionTooltip":"Label-module__labelDescriptionTooltip__Ve0N6VS"};